export default __webpack_public_path__ + "static/Metal_Spike_Wall-30aa9b4f2125c53f308ddd9464dcaceb.png";